import Header from '../CommonComponent/Header';
import NatureBusinessSectors from './NatureBusinessSectors';
import GBPChart from '../CommonComponent/GBPChart';
import TopGBPMinSection from '../CommonComponent/TopGBPMinSection';
import EquityFundraisers from '../CommonComponent/EquityFundraisers';

import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './styles.module.scss';

const UKPrivateCompanyInsightsHome = (props) => {
  const { } = props;

  return (
    <div className={Styles['uk-private-company']}>
      <Header
        showSub
        showAbnormal
        title="UK Private Company Insights"
      />
      <div className={Styles['uk-private-company-chart']}>
        <GBPChart
          isMainPage
          disableHover
        />
      </div>

      <EquityFundraisers />

      <TopGBPMinSection />
      <div className={Styles['uk-private-company-nature']}>
        <NatureBusinessSectors />
      </div>
    </div>
  );
};

export default withMetatag(UKPrivateCompanyInsightsHome, 'directory/companies-insights/uk');
